import React from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/styles";

import CloseIcon from "../Common/CloseIcon";
import { I18n } from "@aws-amplify/core";

import colors from "../../assets/style/colors";


const styles = {
    container: {
        width: 367,
        height: 351
    },
    close: {
        float: "right",
        margin: 10,
        display: "inline",
        top: -43
    },
    title: {
        fontSize: 18,
        color: colors.black87,
        fontWeight: 400,
        display: "table",
        margin: "0 auto",
        marginTop: 15
    }
};

const CalculateQuantity = withStyles(styles)((props) => {
    const {
        // history,
        // language,
        classes,
        unit_weight,
        // setQuantity,
        handleClose,
        weight
    } = props;


    React.useEffect(() => {
        // Clear the item and attributes and fetch the item and the tree.


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className={classes.container}>
            <span className={classes.title}>{I18n.get("calc_quant")}</span>
            <div className={classes.close}>
                <CloseIcon closeFunction={handleClose}/>
            </div>
            <div>
                <span style={{margin: 20, top: 30}}>{I18n.get("unit_weight") + ": " + unit_weight + " " + weight}</span>
            </div>
            
        </div>
    );

});

export default withRouter(CalculateQuantity);
